import { RecipeRegistry, type Recipe, type RecipeIngredient } from "../crafting/RecipeRegistry";

export function loadRecipeRegistry(data: unknown): RecipeRegistry {
  if (!Array.isArray(data)) throw new Error("recipes.json must be an array");
  const registry = new RecipeRegistry();
  for (const raw of data) {
    if (typeof raw !== "object" || raw === null) continue;
    const r = raw as Record<string, unknown>;
    if (
      typeof r["id"] !== "string" ||
      typeof r["knowledgeNodeId"] !== "string" ||
      typeof r["produces"] !== "string" ||
      typeof r["message"] !== "string"
    ) {
      continue;
    }
    const ingredients = parseIngredients(r["ingredients"]);
    if (ingredients.length === 0) continue;
    registry.register({
      id: r["id"],
      knowledgeNodeId: r["knowledgeNodeId"],
      ingredients,
      produces: r["produces"],
      producesQuantity: typeof r["producesQuantity"] === "number" ? r["producesQuantity"] : 1,
      message: r["message"],
    } satisfies Recipe);
  }
  return registry;
}

function parseIngredients(raw: unknown): RecipeIngredient[] {
  if (!Array.isArray(raw)) return [];
  const result: RecipeIngredient[] = [];
  for (const entry of raw) {
    if (typeof entry !== "object" || entry === null) continue;
    const i = entry as Record<string, unknown>;
    if (typeof i["definitionId"] === "string" && typeof i["quantity"] === "number") {
      result.push({ definitionId: i["definitionId"], quantity: i["quantity"] });
    }
  }
  return result;
}
